import React from "react";

const LABELS = {
  "findings":     "Finding",
  "teardowns":    "Teardown",
  "reports":      "Industry Report",
  "case-studies": "Case Study",
  "methodology":  "Methodology",
  "resources":    "Resource",
};

export default function CategoryBadge({ category, className = "" }) {
  const label = LABELS[category] || category;
  return (
    <span className={`inline-block font-mono-eav text-[10px] tracking-[0.22em] uppercase text-[#b8963e] ${className}`}>
      {label}
    </span>
  );
}
